export default class ExpressRejectionList {
    shipment: string;
    reMark: string;
    rejectionTime?: Date;
    createTime: Date;
    id: number;
    warehouseInfoId: number;
    expressCompany: string;
    handleType: number;
    handleStatus: number;
    warehouseName: string;
    revokedTime?: Date;
    userId: string;
    tenantId: number;
    rejectionHandler: string;
    returnHandler: string;
    returnNo: number;
    returnExpressCompany: string;
    recipientInfo: string;
    returnTime?: Date;
    expressCost: number;
    userCode: string;
    packageStatus: number;
    whetherArriveWarehouse: boolean;
    shelfNumber: string;
    receiveStatus: number;
    isShopeeReturn: boolean;
    deductionType: number;
    phone: string;
    receiptAddress: string;
    receiptPhone: string;
    recipientName: string;
    warehouseRemark: string;
    rejectionHandlerName: string;
    returnHandlerName: string;
    orderType: number;
    deductionTime: Date;
    intoHouseName: string;
    signForTime?: Date;
    shopeeReturnTime?: Date;
    imageGuid: string;
}